import { BlockedState, Card, PageContainer, RuntimeDiagnosticBanner, type ComponentDiagnostic } from "@swot/base-components";
import { SwotRbacGate, SwotSmartDataGrid } from "@swot/swot-components";
import type { PermissionContext } from "@swot/swot-components";

export function CmtsAccessGovernancePage(props: {
  permissionContext?: PermissionContext | null | undefined;
  effectiveAccess?: unknown | undefined;
  userPermissions?: readonly unknown[] | undefined;
  diagnostics?: readonly ComponentDiagnostic[] | undefined;
}) {
  const rows = [
    { id: "effective-access", scope: "Current User", contract: "CMTS_API.access.effective", status: props.effectiveAccess ? "loaded" : "not-loaded" },
    { id: "my-permissions", scope: "User Permissions", contract: "CMTS_API.access.userPermissions(userId)", status: props.userPermissions ? "loaded" : "not-loaded" },
    { id: "my-organization-scope", scope: "Organization Scope", contract: "CMTS_API.auth.myOrganizationScope", status: props.permissionContext?.tenantId ? "tenant-scoped" : "tenant-missing" },
  ];
  return (
    <PageContainer title="Access Governance" subtitle="RBAC, SoD, user scope, menu, and permission context readiness for CMTS frontend actions.">
      {/* <RuntimeDiagnosticBanner diagnostics={props.diagnostics ?? []} title="Access diagnostics" /> */}
      <SwotRbacGate permission="AUTH.USER_MANAGE" context={props.permissionContext ?? null} fallback={<BlockedState title="Access governance blocked" message="AUTH.USER_MANAGE permission is required." />}>
        <Card title="Access Contract Checks">
          <SwotSmartDataGrid title="Access governance checks" rows={rows} columns={[{ key: "scope", label: "Scope" }, { key: "contract", label: "API contract" }, { key: "status", label: "Status" }] as any} rowKey="id" enableSearch enableSorting />
        </Card>
      </SwotRbacGate>
    </PageContainer>
  );
}
